import React, { useState } from "react";
import { AppBar, Toolbar, Button, Box, IconButton, Drawer, List,useMediaQuery, useTheme} from "@mui/material";
import PersonIcon from '@mui/icons-material/Person';
import MenuIcon from "@mui/icons-material/Menu";
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness';
import "@fontsource/montserrat";
import { useNavigate } from "react-router-dom";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { useThemeStore } from "../../../../store/themeStore";

const Header = ({selected, setSelected}) => {
  const navigate = useNavigate();
  // const [selected, setSelected] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width:1020px)");
  const isSmallMobile = useMediaQuery("(max-width:480px)");
  const theme = useTheme();
  const mode = useThemeStore((s) => s.mode);
  const toggleTheme = useThemeStore((s) => s.toggle);
  
  const menuItems = [
    { label: "Про нас", path: "/aboutUs" },
    { label: "Сертифікатні програми", path: "/courses" },
    { label: "Підвищення кваліфікації", path: "/qualificationCourses" },
    { label: "Навчальні курси для вступників", path: "/entranceCourses" },
    // { label: "Вебінари", path: "/webinars" },
    // { label: "Кваліфікаційні центри", path: "/qualification-centers" },
   { label: "Викладачі", path: "/allTeachersPage" },
    // { label: "Партнери", path: "/partners" },
    // { label: "Новини", path: "/news" },
  ];

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) return;
    setDrawerOpen(open);
  };

  const onLinkClick = (index, path) => {
    setSelected(index);
    localStorage.setItem("isCourseCreation", false);
    localStorage.setItem("currentPage", 1);
    setDrawerOpen(false); // Закриваємо меню після кліку
    // Додаємо невелику затримку для гарантії закриття
    setTimeout(() => {
      navigate(path);
    }, 100);
  }

  return (
    <Box sx={{ width: "100%", zIndex: 4 }}>
      <AppBar position="static" sx={{ 
        backgroundColor: theme.palette.background.paper, 
        color: theme.palette.text.primary, 
        paddingTop: isMobile ? "8px" : "5px", 
        minHeight: isMobile ? "80px" : "110px", 
        justifyContent: "center",
        boxShadow: isMobile ? "0 2px 8px rgba(0,0,0,0.1)" : "none"
      }}>
        <Toolbar disableGutters sx={{maxWidth:'1300px', width:'100%', margin:"0 auto", display:'flex', justifyContent:"space-between"}}>   
          {isMobile ? (
            // Мобільна версія з бургер-меню
            <Box width={'100%'}>
              <Box sx={{
                display: 'flex', 
                flexDirection: 'row',
                justifyContent: 'space-between', 
                alignItems: 'center',
                minWidth: '100%', 
                px: isSmallMobile ? '4%' : '5%',
                py: 1
              }}>
                {/* Логотип */}
                <Box
                  component="img"
                  src={theme.brand.logo}
                  alt={theme.brand.logoAlt}
                  sx={{
                    height: isSmallMobile ? '60px' : '70px',
                    width: isSmallMobile ? '45px' : '55px',
                    cursor: 'pointer',
                    transition: 'transform 0.2s ease',
                    '&:hover': {
                      transform: 'scale(1.05)'
                    }
                  }}
                  onClick={() => {
                    navigate("/");
                  }}  
                />
                
                {/* Права частина з іконками */}
                <Box sx={{
                  display: 'flex', 
                  alignItems: 'center',
                  gap: isSmallMobile ? 0.5 : 1
                }}>
                  {/* Соціальні мережі - тільки для більших мобільних */}
                  {!isSmallMobile && (
                    <Box sx={{ display: 'flex', gap: 0.5, mr: 1 }}>
                      <Button
                        variant="text"
                        sx={{ 
                          color: theme.palette.text.primary, 
                          minWidth: 'auto', 
                          p: 0.5,
                          borderRadius: '50%',
                          '&:hover': { 
                            color: theme.palette.primary.main, 
                            backgroundColor: 'rgba(0,0,0,0.04)'
                          }
                        }}
                        href="https://www.facebook.com/nubip.edu.ua/"
                        target="_blank"
                      >
                        <FaFacebook size={30} />
                      </Button>
                      <Button
                        variant="text"
                        sx={{ 
                          color: theme.palette.text.primary, 
                          minWidth: 'auto', 
                          p: 0.5,
                          borderRadius: '50%',
                          '&:hover': { 
                            color: theme.palette.social.insta, 
                            backgroundColor: 'rgba(0,0,0,0.04)'
                          }
                        }}
                        href="https://www.instagram.com/nubip.1898/"
                        target="_blank"
                      >
                        <FaInstagram size={30} />
                      </Button>
                    </Box>
                  )}
                  
                  {/* Кнопки дій */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    {/* Кнопка входу */}
                    <Button
                      variant="text"
                      sx={{ 
                        color: theme.palette.social.person, 
                        minWidth: 'auto', 
                        p: 0.5,
                        borderRadius: '50%',
                        '&:hover': { 
                          backgroundColor: 'rgba(0,0,0,0.04)'
                        }
                      }}
                      href="https://ecourses.nubip.edu.ua/login/index.php"
                      target="_blank"
                    >
                      <PersonIcon sx={{ fontSize: isSmallMobile ? 28 : 32 }} />
                    </Button>
                    
                    {/* Кнопка теми */}
                    <IconButton
                      color="inherit"
                      onClick={toggleTheme}
                      sx={{ 
                        color: theme.palette.text.primary, 
                        minWidth: 'auto', 
                        p: 0.5,
                        borderRadius: '50%',
                        '&:hover': { 
                          backgroundColor: 'rgba(0,0,0,0.04)'
                        }
                      }}
                      title={mode === 'system' ? 'Системна тема' : mode === 'dark' ? 'Темна тема' : 'Світла тема'}
                      aria-label="toggle theme"
                    >
                      {mode === 'system' ? (
                        <SettingsBrightnessIcon sx={{ fontSize: isSmallMobile ? 28 : 32 }} />
                      ) : mode === 'dark' ? (
                        <DarkModeIcon sx={{ fontSize: isSmallMobile ? 28 : 32 }} />
                      ) : (
                        <LightModeIcon sx={{ fontSize: isSmallMobile ? 28 : 32 }} />
                      )}
                    </IconButton>
                    
                    {/* Бургер меню */}
                    <IconButton 
                      color="inherit" 
                      onClick={toggleDrawer(true)} 
                      sx={{ 
                        color: theme.palette.social.person,
                        p: 0.5,
                        borderRadius: '50%',
                        '&:hover': { 
                          backgroundColor: 'rgba(0,0,0,0.04)'
                        }
                      }}
                    >
                      <MenuIcon sx={{ fontSize: isSmallMobile ? 32 : 36 }} />
                    </IconButton>
                  </Box>
                </Box>
              </Box>
              <Drawer 
                anchor="right" 
                open={drawerOpen} 
                onClose={toggleDrawer(false)}
                sx={{ 
                  "& .MuiDrawer-paper": { 
                    width: "100vw", 
                    height: "100vh", 
                    backgroundColor: theme.palette.background.paper,
                    display: 'flex',
                    flexDirection: 'column'
                  } 
                }}
              >
                {/* Заголовок меню */}
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  p: 2,
                  borderBottom: `1px solid ${theme.palette.divider}`,
                  minHeight: '60px'
                }}>
                  <Box
                    component="img"
                    src={theme.brand.logo}
                    alt={theme.brand.logoAlt}
                    sx={{
                      height: '50px',
                      width: '38px',
                      cursor: 'pointer',
                      transition: 'transform 0.2s ease',
                      '&:hover': {
                        transform: 'scale(1.05)'
                      }
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setDrawerOpen(false);
                      setTimeout(() => {
                        navigate("/");
                      }, 100);
                    }}
                  />
                  <IconButton 
                    onClick={toggleDrawer(false)}
                    sx={{ 
                      color: theme.palette.text.primary,
                      '&:hover': { 
                        backgroundColor: 'rgba(0,0,0,0.04)'
                      }
                    }}
                  >
                    <MenuIcon sx={{ fontSize: 28 }} />
                  </IconButton>
                </Box>

                {/* Меню навігації */}
                <List sx={{ 
                  width: "100%", 
                  flex: 1,
                  py: 2,
                  '& .MuiListItem-root': {
                    px: 0
                  }
                }}>
                  {menuItems.map((item, index) => (
                    <Box key={item.label} sx={{ 
                      display: "flex", 
                      justifyContent: "center",
                      mb: 0.5
                    }}>
                      <Button
                        variant="text"
                        sx={{
                          fontFamily: "Montserrat",
                          fontSize: isSmallMobile ? "16px" : "18px",
                          padding: isSmallMobile ? "12px 24px" : "16px 32px",
                          color: theme.palette.text.primary,
                          fontWeight: selected === index ? "bold" : "normal",
                          textTransform: "capitalize",
                          borderRadius: '8px',
                          width: '90%',
                          justifyContent: 'flex-start',
                          backgroundColor: selected === index ? theme.palette.primary.light + '20' : 'transparent',
                          '&:hover': { 
                            backgroundColor: theme.palette.primary.light + '10',
                            color: theme.palette.primary.main
                          },
                          transition: 'all 0.2s ease'
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setDrawerOpen(false);
                          onLinkClick(index, item.path);
                        }}
                      >
                        {item.label}
                      </Button>
                    </Box>
                  ))}
                </List>

                {/* Нижня частина з соціальними мережами */}
                <Box sx={{
                  p: 2,
                  borderTop: `1px solid ${theme.palette.divider}`,
                  display: 'flex',
                  justifyContent: 'center',
                  gap: 2
                }}>
                  <Button
                    variant="text"
                    sx={{ 
                      color: theme.palette.text.primary, 
                      minWidth: 'auto', 
                      p: 1,
                      borderRadius: '50%',
                      '&:hover': { 
                        color: theme.palette.primary.main, 
                        backgroundColor: 'rgba(0,0,0,0.04)'
                      }
                    }}
                    href="https://www.facebook.com/nubip.edu.ua/"
                    target="_blank"
                    onClick={(e) => {
                      e.preventDefault();
                      setDrawerOpen(false);
                    }}
                  >
                    <FaFacebook size={24} />
                  </Button>
                  <Button
                    variant="text"
                    sx={{ 
                      color: theme.palette.text.primary, 
                      minWidth: 'auto', 
                      p: 1,
                      borderRadius: '50%',
                      '&:hover': { 
                        color: theme.palette.social.insta, 
                        backgroundColor: 'rgba(0,0,0,0.04)'
                      }
                    }}
                    href="https://www.instagram.com/nubip.1898/"
                    target="_blank"
                    onClick={(e) => {
                      e.preventDefault();
                      setDrawerOpen(false);
                    }}
                  >
                    <FaInstagram size={24} />
                  </Button>
                </Box>
              </Drawer>
            </Box>
          ) : (
            // Десктопна версія з кнопками
            <>
            <Box
            onClick={() => {
              navigate("/aboutUs");
              localStorage.setItem("isCourseCreation", false);
            }}
            component="img"
            src={theme.brand.logo}
            alt={theme.brand.logoAlt}
            sx={{ height: 88,paddingLeft:'40px', mr: 3, cursor: "pointer",}}
          />
             <Box container spacing={2} justifyContent="center" alignItems="center" sx={{ flexGrow: 1, display: "flex", justifyContent: "center", flexDirection: "row" }}>
      {menuItems.map((item, index) => (
        <Box sx={{ display: "flex", alignItems: "center" }} key={item.label}>
          <Button
            variant="text"
            sx={{
              fontFamily: "Montserrat",
              fontSize: "14px",
              paddingRight: "15px",
              textTransform: "capitalize", 
              justifyContent: "flex-start",
              color: theme.palette.text.primary,
              borderRight: item.label !== "Новини" ? `1px solid black` : "none",
              borderRadius: 0,
              fontWeight: selected === index ? "bold" : "normal",
              "&:hover": { color: theme.palette.text.primary },
              
            }}
            size="medium"
            onClick={() => onLinkClick(index, item.path)}
          >
            {item.label}
          </Button>
        </Box>
      ))}
    </Box>
            </>
          )}

          {/* Іконки соцмереж */}
          {!isMobile && (
            <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <Button variant="text" sx={{ color: theme.palette.text.primary, ":hover":{ color: theme.palette.social.fb, background: 'transparent'} }} href="https://www.facebook.com/nubip.edu.ua/" target="_blank">
                <FaFacebook size={30} />
              </Button>
              <Button variant="text" sx={{ color: theme.palette.text.primary, ":hover":{ color: theme.palette.social.insta, background: 'transparent'} }} href="https://www.instagram.com/nubip.1898/" target="_blank">
                <FaInstagram size={30} />
              </Button>
              <Button variant="text" sx={{ color: theme.palette.text.primary, ":hover":{ color: theme.palette.social.person, background: 'transparent'} }} href="https://ecourses.nubip.edu.ua/login/index.php">
                <PersonIcon sx={{ fontSize: 28 }} />
              </Button>
              <IconButton
                color="inherit"
                onClick={toggleTheme}
                sx={{ color: theme.palette.text.primary, ":hover":{ color: theme.palette.text.primary, background: 'transparent'} }}
                title={mode === 'system' ? 'Системна тема' : mode === 'dark' ? 'Темна тема' : 'Світла тема'}
                aria-label="toggle theme"
              >
                {mode === 'system' ? (
                  <SettingsBrightnessIcon />
                ) : mode === 'dark' ? (
                  <DarkModeIcon />
                ) : (
                  <LightModeIcon />
                )}
              </IconButton>
            </Box>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Header;
